import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkboxes, FileInput, RadioButtons, TabPanel, Dropdown } from '../../../FlowConfigurationInputs';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import { CheckIfFlowUpdated } from '../../../../helpers/helper';
import { changedFields, initialActions, saveAvailable } from '../../../../recoil-store/recoil-state';
import { useRecoilValue, useSetRecoilState } from 'recoil';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @param       action
 * @param       showAlert -  show alert
 * @param       setOpenVariable
 * @param       variables
 * @Returns     Component
 * @Author      Onur DOGUCU
 */
function AddHeader({ action, showAlert, setOpenVariable, variables }) {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const [headingType, setHeadingType] = useState("");
    const initialActionsData = useRecoilValue(initialActions);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setChangeFields = useSetRecoilState(changedFields);
    const changedFieldsState = useRecoilValue(changedFields);
    const label = 'CONTENT.CONFIGURATION-FORM.WORD.ADD-HEADER.';


    const BootstrapInput = withStyles((theme) => ({
        root: {
            'label + &': {
                marginTop: theme.spacing(3),
            },
        },
        input: {
            borderRadius: 2,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '0.5px solid #D5D5D5',
            paddingLeft: 5,
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.

        },
    }))(InputBase);

    useEffect(() => {
        if (!action.fields.headingType)
            action.fields.headingType = { value: "" };
        else
            setHeadingType(action.fields.headingType.value)

    }, [action])

    function handleHeadingType(event) {
        let actionId;
        setHeadingType(event.target.value);
        if (!action.fields.headingType) {
            action.fields.headingType = { value: event.target.value };
        } else {
            action.fields.headingType.value = event.target.value;
        }
        if (action.id) {
            actionId = action.id;
        }
        const field = initialActionsData[actionId]?.fields[headingType];
        const oldValue = !field ? undefined : field.value;
        CheckIfFlowUpdated(headingType, action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);
    }

    return (
        <div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'WORD-SOURCE')} is_required />
                <VariablePicker action={action} inputName="wordSource" variables={variables}
                    setOpenVariable={setOpenVariable} filter="array" isRequired hideRequired />
                <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + 'HEADER-DATA')} is_required />
                <TextInput action={action} inputName="headerData" variables={variables}
                    setOpenVariable={setOpenVariable} isRequired={true} hideRequired />
            </div>
            <div className="conf-field-container">
                <FieldLabel name={t(label + "HEADING-TYPE")} is_required />
                <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
                    <Select value={headingType} onChange={handleHeadingType}
                        input={(headingType) ? null : <BootstrapInput />}>
                        <MenuItem value="h1">Heading 1</MenuItem>
                        <MenuItem value="h2">Heading 2</MenuItem>
                        <MenuItem value="h3">Heading 3</MenuItem>
                        <MenuItem value="h4">Heading 4</MenuItem>
                        <MenuItem value="h5">Heading 5</MenuItem>
                    </Select>
                </FormControl>
            </div>
        </div>
    )
}

export default AddHeader;
